export type FilterOptions = "genders" | "ethnicities" | "workingLocations";

export const FilterTitles: Record<FilterOptions, string> = {
  genders: "Gender",
  ethnicities: "Ethnicity",
  workingLocations: "Working location",
};
